import { Icons } from '@/app/components/ui/Icons'
import { FC, ReactNode } from 'react'
import '@/app/styles/components/common/SelectorButton.css'

interface SelectorButtonProps {
	icon: ReactNode
	title: string
	subtitle: string
	isOpen: boolean
	onClick: () => void
	ariaControls: string
	'data-testid'?: string
	langCode?: string
}

const SelectorButton: FC<SelectorButtonProps> = ({
	icon,
	title,
	subtitle,
	isOpen,
	onClick,
	ariaControls,
	'data-testid': dataTestId,
	langCode,
}) => {
	return (
		<button
			className={`selector-button ${isOpen ? 'selector-button--open' : ''}`}
			onClick={onClick}
			aria-expanded={isOpen}
			aria-controls={ariaControls}
			data-testid={dataTestId}
		>
			<div className="selector-button__content">
				<div className="selector-button__flag text-text-950" aria-hidden="true">
					{icon}
				</div>
				<div className="selector-button__text-container">
					<span
						className="selector-button__title"
						data-lang-code={langCode}
					>
						{title}
					</span>
					<span className="selector-button__subtitle">{subtitle}</span>
				</div>
			</div>
			<Icons.caret
				className={`selector-button__icon ${isOpen ? 'selector-button__icon--open' : ''}`}
				aria-hidden="true"
			/>
		</button>
	)
}

export default SelectorButton
